<ng-container *ngIf="!tooltipText">
  <div class="label-container">{{ labelText }}</div>
</ng-container>

<ng-container *ngIf="tooltipText">
  <ng-template #tooltipTemplate>
    <div class="tooltip">
      {{ tooltipText }}
    </div>
  </ng-template>

  <div class="label-container">
    {{ labelText }}
    <div
      class="info-icon-wrapper"
      [uiTooltip]="tooltipTemplate"
      [uiTooltipTheme]="'dark'"
      [uiTooltipOpenTimeout]="500"
      [uiTooltipTriggerOpenEvent]="'mouseenter'"
      [uiTooltipTriggerDestroyEvent]="'mouseleave'"
      [uiTooltipPosition]="tooltipPosition"
      [uiTooltipShowArrow]="true"
    >
      <img src="{{ 'icons/info-blue.svg' | assetsPath | async }}" width="16" height="16" />
    </div>
  </div>
</ng-container>
